import { ToastService } from './_toast/_toast.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppError } from '@models/appError';

@Injectable({ providedIn: 'root' })
export class ApiHttpService {
  constructor(private http: HttpClient, private toastService: ToastService) {}

  public get<T>(url: string): Observable<T> {
    return this.http.get<T>(url, { withCredentials: true });
  }
  public post<T>(url: string, data: any): Observable<T> {
    return this.http.post<T>(url, data, { withCredentials: true });
  }
  public put<T>(url: string, data: any): Observable<T> {
    return this.http.put<T>(url, data, { withCredentials: true });
  }
  public delete<T>(url: string): Observable<T> {
    return this.http.delete<T>(url, { withCredentials: true });
  }

  public handle(error: AppError, toastDuration: number = null): void {
    // Can handle specific status codes here
    // Show a slightly more user firendly 401
    if (error.status === 401) {
      this.toastService.showError(
        'You are not authorized to do that...',
        toastDuration
      );
      return;
    }

    this.toastService.showError(error.formatErrorForToast(), toastDuration);
  }

  public download(url: string): Observable<Blob> {
    return this.http.get(url, {
      responseType: 'blob',
    });
  }
}
